var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnarchiveBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4444 7.69556H2.88889L0 11.9347V18.9999H17.3333V11.9347L14.4444 7.69556ZM11.5556 11.9347C11.5556 12.6842 11.2512 13.403 10.7094 13.933C10.1676 14.463 9.43285 14.7608 8.66667 14.7608C7.90049 14.7608 7.16568 14.463 6.62391 13.933C6.08214 13.403 5.77778 12.6842 5.77778 11.9347H1.73333L3.65444 9.1086H13.6789L15.6 11.9347H11.5556Z",
    fill: "#438AFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.92622 6.60715L2.63768 6.60715L8.66667 0.913105L14.6956 6.60715L11.4071 6.60715L11.4071 10.7102L5.92622 10.7102L5.92622 6.60715Z",
    fill: "#438AFE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnarchiveBlue);
export default __webpack_public_path__ + "static/media/unarchive-blue.8b4aba7b.svg";
export { ForwardRef as ReactComponent };